import { tailwindColors } from '@repo/tailwind-config/tailwind.vars'
import Badge from '@repo/ui/badge'
import Typography from '@repo/ui/typography'
import { ReactNode } from 'react'

type Props = {
  icon: ReactNode
  title: string
  subtitle?: ReactNode
  subTitlePosition?: 'beside' | 'above'
}

const ClientSpacePageTitle = ({ icon, title, subtitle, subTitlePosition = 'above' }: Props) => {
  return (
    <div className="flex flex-col gap-2 ">
      {subTitlePosition === 'above' && subtitle}
      <div className="flex items-center gap-2">
        <Badge icon={icon} variant="primary" size="flexible" className="rounded" />
        <Typography variant="h3" color={tailwindColors.primary.dark.DEFAULT}>
          {title}
        </Typography>
        {subTitlePosition === 'beside' && <div className="mobile:hidden">{subtitle}</div>}
      </div>
      {subTitlePosition === 'beside' && <div className="hidden mobile:block">{subtitle}</div>}
    </div>
  )
}

export default ClientSpacePageTitle
